import {
  getLocalStorageMeasureCardMuteHistory,
  MuteHistoryEntry,
  setLocalStorageMeasureCardMuteHistory,
} from "api/dropsLocalStorage";
import { useCallback, useEffect, useState } from "react";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";

export const ALWAYS_MUTED_STATES = new Set(["CLOSED", "DEPUBLISHED"]);

export function useMeasureCardMuteHistory(
  uuid: string,
  informationState: CombinedHistoryResponse["state"],
) {
  const [muteHistory, setMuteHistory] = useState<MuteHistoryEntry[]>([]);

  const isMuted =
    ALWAYS_MUTED_STATES.has(informationState) ||
    (!!muteHistory.length && muteHistory[0].action === "muted");

  const addMuteHistoryEntry = useCallback(
    (entry: MuteHistoryEntry) => {
      const newMuteHistory = [entry, ...muteHistory];
      setLocalStorageMeasureCardMuteHistory(uuid, newMuteHistory);
      setMuteHistory(newMuteHistory);
    },
    [muteHistory, uuid],
  );

  useEffect(() => {
    setMuteHistory(getLocalStorageMeasureCardMuteHistory(uuid));
  }, [uuid]);

  return {
    muteHistory,
    isMuted,
    addMuteHistoryEntry,
  };
}
